@if (systemMessages.data$.value.length) {
  <div>
    @for (message of systemMessages.data$.value; track message) {
      <nsc-card [error]="true" [className]="message.className">
        <nsc-card-title-error title="{{message.titleDescription}}" [className]="message.className"
          icon="{{message.icon}}">
          <div>
            <span [innerHtml]="message.message | safeHtml:'html'"></span>
          </div>
        </nsc-card-title-error>
      </nsc-card>
      <nsc-spacer size="xs"></nsc-spacer>
    }
    <nsc-spacer size="xs"></nsc-spacer>
    <nsc-spacer size="xs"></nsc-spacer>
  </div>
}